<div class="divMessage" [class.show]="model.show" (click)="close();">
    <div class="texto" [innerHTML]="model.message">
    </div>
    <div class="fechar">
        X
    </div>
</div>